/**
 * Iron & Acre — GBB Variant Dropdown Fix
 *
 * Fixes two bugs with the variant dropdown on the builder page:
 *
 * Bug 1 — Flicker on open:
 *   The original toggle function removes "gbbVariantDropdownOpen" from ALL
 *   wrappers, then checks jQuery .css("max-height") to decide whether to
 *   re-add it. jQuery reads the CSS property value (always "0px" from the GBB
 *   base rule), not the computed/animated value — so the check always returns
 *   false, causing the dropdown to always try to open while the close animation
 *   is already running. Result: visible flicker.
 *   Fix: read classList.contains("gbbVariantDropdownOpen") BEFORE removing.
 *
 * Bug 2 — Options covered by next product card:
 *   The options list is position:absolute with z-index:50, but its parent
 *   gbbVariantDropdownWrapper has z-index:auto. This means the z-index only
 *   applies within the wrapper's stacking context. The next product card
 *   (also position:relative, z-index:auto, but later in the DOM) paints on
 *   top of the options list, making lower options unclickable.
 *   Fix: when a dropdown opens, give its gbbProductItem z-index:10 so it
 *   stacks above all sibling cards. Reset to auto on close.
 */

(function patchGBBVariantDropdown() {
  var maxAttempts = 60;
  var attempts = 0;

  function resetAllProductItemZ() {
    document.querySelectorAll('.gbbProductItem').forEach(function (el) {
      el.style.zIndex = '';
      el.style.position = '';
    });
  }

  function tryPatch() {
    attempts++;

    if (
      typeof gbb !== 'undefined' &&
      gbb.gbbAddProductsPage &&
      gbb.gbbAddProductsPage.f &&
      typeof gbb.gbbAddProductsPage.f.toggleVariantDropdownAndDrawer === 'function'
    ) {
      gbb.gbbAddProductsPage.f.toggleVariantDropdownAndDrawer = function () {
        try {
          // On mobile, use the drawer instead of dropdown
          if (window.innerWidth < 600) {
            var productId = gbb.$(this).parents('.gbbProductItem').attr('productid');
            var productData = gbb.utility.getProductDetailsFromState(productId);
            gbb.gbbAddProductsPage.f.setupVariantDrawer(productData);
            gbb.utility.toggleDrawerStatus('gbbVariantSelector');
            return;
          }

          // Bug 1 fix: read open state BEFORE removing all classes
          var $wrapper = gbb.$(this).parent('.gbbVariantDropdownWrapper');
          var isCurrentlyOpen = $wrapper.hasClass('gbbVariantDropdownOpen');

          // Close all open dropdowns and reset all z-index overrides
          gbb.$('.gbbVariantDropdownWrapper').removeClass('gbbVariantDropdownOpen');
          resetAllProductItemZ();

          // Only open if it was previously closed
          if (!isCurrentlyOpen) {
            $wrapper.addClass('gbbVariantDropdownOpen');

            // Bug 2 fix: elevate this product card above its siblings
            var productItem = gbb.$(this).closest('.gbbProductItem')[0];
            if (productItem) {
              productItem.style.position = 'relative';
              productItem.style.zIndex = '100';
            }
          }
        } catch (e) {
          gbb.utility.debugError('error in toggleVariantDropdownAndDrawer', e);
        }
      };

      // Also close dropdown + reset z-index when clicking outside
      document.addEventListener('click', function (e) {
        var clickedInsideDropdown = e.target.closest('.gbbVariantDropdownWrapper');
        if (!clickedInsideDropdown) {
          var anyOpen = document.querySelector('.gbbVariantDropdownWrapper.gbbVariantDropdownOpen');
          if (anyOpen) {
            gbb.$('.gbbVariantDropdownWrapper').removeClass('gbbVariantDropdownOpen');
            resetAllProductItemZ();
          }
        }
      }, true);

      console.log('[Iron & Acre] GBB variant dropdown fix applied (flicker + z-index).');
    } else if (attempts < maxAttempts) {
      setTimeout(tryPatch, 500);
    } else {
      console.warn('[Iron & Acre] GBB variant dropdown fix: gbb app not found after ' + maxAttempts + ' attempts.');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(tryPatch, 1000); });
  } else {
    setTimeout(tryPatch, 1000);
  }
})();
